'use client'

import { useEffect, useState } from 'react'
import { TranslationsList, TRANSLATIONS_EN, TRANSLATIONS_NL } from '@/constants/translations'

export const useTranslations = () => {
    const [translations, setTranslations] = useState<TranslationsList>()

    useEffect(() => {
        setTranslations(getTranslations())
    }, [])

    const getTranslations = (): TranslationsList => (getLocale() === 'en' ? TRANSLATIONS_EN : TRANSLATIONS_NL)

    const getLocale = (): 'nl' | 'en' => {
        const locale: string = window?.navigator?.language?.slice(0, 2)
        return locale === 'en' ? 'en' : 'nl'
    }

    const translate = (key: string) => translations?.[key] || key

    return translate
}
